<template>
  <div class="addNewClass">
    <div class="content">
      <el-row>
        <el-button
          type="primary"
          round
          @click="
            (addSortCon = true), (makeBtnStatus = true), (showImage = true)
          "
          >添加分类</el-button
        >
      </el-row>
      <el-table
        border
        row-key="id"
        :data="tableData"
        v-loading="loading"
        default-expand-all
        element-loading-text="拼命加载中"
        style="width: 100%;margin-bottom: 20px;margin-top: 20px"
        :tree-props="{ children: 'children', hasChildren: 'child' }"
      >
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->
        <el-table-column prop="sort" label="排序" sortable width="180">
        </el-table-column>
        <el-table-column prop="name" label="名称" sortable width="180">
        </el-table-column>
        <el-table-column prop="des" label="描述"> </el-table-column>
        <el-table-column prop="adv_link" label="广告链接"> </el-table-column>
        <!-- <el-table-column
          prop="search_group_ids"
          label="筛选项">
          <template slot-scope="scope">
            <span v-for="(item, idx) in scope.row.search_group_ids" :key="idx">
              {{item}}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column prop="status" label="是否显示">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == 1 ? 'success' : 'danger'"
              effect="dark"
            >
              {{ scope.row.status == 1 ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="
                (addSortCon = true),
                  (nowParent_id = scope.row.id),
                  (makeBtnStatus = true),
                  (showImage = false)
              "
            >
              添加
            </el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="mini"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加分类" :visible.sync="addSortCon" @close="closeDialog">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input
            type="number"
            min="0"
            v-model="form.sort"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="name"
          label="分类名称"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类广告链接" :label-width="formLabelWidth">
          <el-input v-model="form.adv_link" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="筛选项组" :label-width="formLabelWidth">
          <el-transfer
            filterable
            filter-placeholder="请输入筛选组名称"
            v-model="value"
            @change="handleChange"
            :props="{
              key: 'id',
              label: 'name'
            }"
            :titles="['所有筛选项', '已选择']"
            :data="screendata"
          >
          </el-transfer>
        </el-form-item>

        <!--添加品牌内容-->
        <!-- <el-dialog
          width="30%"
          title="添加品牌"
          :visible.sync="brandStatus"
          append-to-body>
            <el-form-item label="排序" :label-width="formLabelWidth">
              <el-input v-model="brandItem.sort" min="0" autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item label="品牌名称" :label-width="formLabelWidth">
              <el-input v-model="brandItem.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="品牌logo" :label-width="formLabelWidth">
              <el-upload
                name="image"
                :data="imgdata"
                class="avatar-uploader"
                :show-file-list="false"
                accept="image/jpeg,image/gif,image/png"
                action="https://www.58zltc.com/api/Upload/uploads/"
                :on-success="adLogoSuccess"
                :before-upload="beforeLogoUpload">
                <img v-if="logoUrl" :src="logoUrl" class="avatar1">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <div slot="footer" class="dialog-footer">
              <el-button @click="brandStatus = false">取 消</el-button>
              <el-button v-if="makeBtnStatus" type="primary" @click="saveBrandItem">确 定</el-button>
              <el-button v-else type="primary" @click="makeChange">修 改</el-button>
            </div>
        </el-dialog> -->

        <!--添加状态-->
        <!-- <el-form-item v-if="makeBtnStatus" label="品牌内容展示" :label-width="formLabelWidth">
          <el-row :gutter="16">
            <el-col :span="4" v-for="(item, idx) in brandArr" :key="idx">
              <div class="brand-con">
                 <el-avatar shape="square" :size="80" fit="cover" :src="item.logo_img"></el-avatar>
                <span>{{item.name}}</span>
              </div>
            </el-col>
            <el-button type="text" @click="brandStatus = true">添加品牌</el-button>
          </el-row>
        </el-form-item> -->
        <!--修改状态-->
        <!-- <el-form-item v-else label="品牌内容展示" :label-width="formLabelWidth">
          <el-row :gutter="16">
            <el-button type="text" @click="brandStatus = true">添加品牌</el-button>
            <el-table
              :data="brandArr"
              border
              max-height="250"
              style="width: 100%">
              <el-table-column
                fixed
                prop="name"
                label="名称"
                width="150">
              </el-table-column>
              <el-table-column
                fixed
                prop="id"
                label="排序"
                width="150">
              </el-table-column>
              <el-table-column
                fixed
                prop="logo_img"
                label="logo图片"
                >
                <template slot-scope="scope">
                  <el-avatar shape="square" :size="40" fit="cover" :src="scope.row.logo_img"></el-avatar>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                label="操作"
                width="150">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="changeBrand(scope.row)">修改</el-button>
                  <el-button type="text" size="small" @click="deleteBrand(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form-item> -->

        <el-form-item
          label="分类轮播图"
          :label-width="formLabelWidth"
          v-if="showImage"
        >
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :http-request="
              file => {
                return productUploadImg(file);
              }
            "
            :on-remove="file => handleRemove(file)"
            :file-list="fileListData"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="分类图片" :label-width="formLabelWidth" v-else>
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="https://www.58zltc.com/api/Upload/uploads/"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
            :data="imgdata"
            :on-change="changefile"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar2" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="是否显示" :label-width="formLabelWidth">
          <el-radio v-model="form.status" label="1">显示</el-radio>
          <el-radio v-model="form.status" label="2">隐藏</el-radio>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="form.des"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>

        <el-button
          v-if="makeBtnStatus"
          type="primary"
          @click="make_con('ruleForm')"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="edit_con('ruleForm')"
          >修 改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isURL } from "@/utils/spilturl";
import { mapGetters } from "vuex";
import { addImage } from "@/api/comment";
import {
  getShopGoodsList,
  deleteShopSorts,
  addShopSorts,
  editShopSorts,
  getDeatil,
  getGoodscate
} from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  watch: {
    // 判断当前是修改状态还是添加状态
    makeBtnStatus: function(val) {
      if (val) {
        this.brandArr = [];
        this.form = {
          // 表单内容
          name: "",
          parent_id: 0,
          image_id: "",
          adv_link: "",
          des: "",
          status: "1",
          brand: {
            name: [],
            logo: [],
            sort: []
          },
          param: {
            name: []
          },
          image_ids: ""
        };
      }
    }
  },
  data() {
    const generateData = _ => {
      const data = [];
      const cities = ["上海", "北京", "广州", "深圳", "南京", "西安", "成都"];
      const pinyin = [
        "shanghai",
        "beijing",
        "guangzhou",
        "shenzhen",
        "nanjing",
        "xian",
        "chengdu"
      ];
      cities.forEach((city, index) => {
        data.push({
          label: city,
          key: index,
          pinyin: pinyin[index]
        });
      });
      return data;
    };
    return {
      screendata: generateData(),
      value: [],

      multipleSelection: [],
      tableData: [], // 分类数据
      addSortCon: false, // 添加分类内容状态
      brandStatus: false, // 添加品牌内容状态
      formLabelWidth: "140px",
      inputVisible: false,
      inputValue: "",

      makeBtnStatus: true,

      updatetId: "", //更新使用id

      nowParent_id: "",
      imgdata: {},
      loading: true,
      imageUrl: "", // 广告上传
      logoUrl: "", // 当前品牌logo上传

      brandArr: [],
      brandItem: {
        name: "",
        logo: "",
        sort: ""
      },
      detailObj: {},
      form: {
        // 表单内容
        name: "",
        parent_id: 0,
        image_id: "",
        adv_link: "",
        des: "",
        status: "1",
        image_ids: ""
      },
      chosepictireid: [], //已上传图片id数组暂存
      fileListData: [], //上传的图片列表
      fakefileList: [], //假的filelist列表
      showImage: false, //是否显示轮播图上传
      rules: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 获取筛选项列表
    getScreenList() {
      getGoodscate({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 1) {
          this.screendata = res.data;
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 获取分类层级
    getAllLevel() {
      // 获取分类层级
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      getShopGoodsList(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.tableData = res.data;
          } else {
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 详情品牌数据整理
    // setDataBrand() {
    //   var obj = { id: [], sort: [], logo: [], name:[] };
    //   try {
    //     if (this.brandArr.length > 0) {
    //       this.brandArr.forEach((item, idx) => {
    //         obj.id.push(item.id);
    //         obj.sort.push(item.sort);
    //         obj.logo.push(item.logo);
    //         obj.name.push(item.name);
    //       })
    //     } else {
    //       throw("暂无品牌数据..");
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    //   return obj;
    // },

    // 添加品牌内容（品牌添加状态）
    // saveBrandItem() {
    //   try {
    //     if (!this.brandItem.sort) throw("请输入排序大小");
    //     if (!this.brandItem.name) throw("请输入品牌名称");
    //     if (!this.brandItem.logo) throw("请上传品牌logo");
    //     this.form.brand.sort.push(this.brandItem.sort);
    //     this.form.brand.name.push(this.brandItem.name);
    //     this.form.brand.logo.push(this.brandItem.logo);
    //     // 品牌展示列表
    //     this.brandItem.logo_img = this.logoUrl;
    //     this.brandArr.push(this.brandItem);
    //     this.brandStatus = false;
    //   } catch (error) {
    //     this.$message(error);
    //   }
    // },
    // 整理修改品牌数据
    // makeChange() {
    //   if (!this.brandItem.sort) throw("请输入排序大小");
    //   if (!this.brandItem.name) throw("请输入品牌名称");
    //   if (!this.brandItem.logo) throw("请上传品牌logo");
    //   try {
    //     let obj = this.setDataBrand();
    //     obj.id.push(this.brandItem.id);
    //     obj.sort.push(this.brandItem.sort);
    //     obj.name.push(this.brandItem.name);
    //     obj.logo.push(this.brandItem.logo);
    //     this.form.brand = obj;
    //     this.brandStatus = false;
    //     console.log(this.form);
    //   } catch (error) {
    //     this.$message(error);
    //   }
    // },
    // 修改品牌（修改状态）
    // changeBrand(item) {
    //   this.brandStatus = true;
    //   this.brandItem.name = item.name;
    //   this.logoUrl = item.logo_img;
    //   this.brandItem.sort = item.sort;
    //   this.brandItem.logo = item.logo;
    //   this.brandItem.id = item.id;
    // },
    // 删除品牌
    // deleteBrand(idx, item) {
    //   var obj = this.setDataBrand();
    //   this.$confirm('确认删除该品牌？')
    //   .then(_ => {
    //     this.brandArr.splice(idx, 1);
    //     for (let i in obj) {
    //       obj[i].splice(idx, 1);
    //     }
    //     this.form.brand = obj;
    //   })
    //   .catch(_ => {});
    // },
    // 穿梭框数据
    handleChange(value, direction, movedKeys) {
      this.value = value;
    },
    // 提交表单
    make_con(formName, item) {
      console.log(this.form);
      this.form.token = this.token;
      this.form.app_id = this.app_id;
      if (this.nowParent_id) {
        this.form.parent_id = this.nowParent_id;
      }
      console.log(this.value);
      this.form.search_group_ids = this.value.join(",");
      this.$refs[formName].validate(valid => {
        if (valid) {
          addShopSorts(this.form).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              // 更新表格
              this.getAllLevel();
              this.addSortCon = false;
              this.showImage = false;
              this.fakefileList = [];
              this.fileListData = [];
              this.chosepictireid = [];
            } else {
              this.$message.danger(res.msg);
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除分类
    handleDelete(index, item) {
      this.$confirm("确认删除该分类？")
        .then(_ => {
          deleteShopSorts({
            token: this.token,
            app_id: this.app_id,
            id: item.id
          }).then(res => {
            this.$message(res.msg);
            // 更新表格
            this.getAllLevel();
          });
          done();
        })
        .catch(_ => {});
    },
    // 获取分类详细信息
    handleEdit(idx, item) {
      this.makeBtnStatus = false;
      this.updatetId = item.id;
      getDeatil({ token: this.token, app_id: this.app_id, id: item.id }).then(
        res => {
          if (res.code == 1) {
            const {
              adv_link,
              des,
              parent_id,
              sort,
              name,
              status,
              brand,
              params,
              image_ids
            } = res.data;
            // 赋值
            this.form = {
              name,
              parent_id,
              adv_link,
              des,
              status: status.toString(),
              sort,
              image_ids
            };
            if (this.form.parent_id) {
              this.showImage = false;
            } else {
              this.showImage = true;
            }
            this.addSortCon = true;
            // 轮播图
            this.fileListData = res.data.image_ids_url;
            this.fakefileList = res.data.image_ids_url;
            this.chosepictireid = image_ids ? image_ids.split(",") : [];
            // 分类图片
            this.imageUrl = res.data.image_url;
            console.log(this.imageUrl);
            // 穿梭框渲染
            var arr = res.data;
            var newvalue = arr.search_group_ids.split(",");
          }
        }
      );
    },
    // 修改分类信息
    edit_con(val) {
      console.log(this.form);
      // return false;
      this.form.token = this.token;
      this.form.app_id = this.app_id;
      this.form.id = this.updatetId;
      if (this.value.length > 0) {
        this.form.search_group_ids = this.value.join(",");
      } else {
        this.form.search_group_ids = "";
      }
      this.$refs[val].validate(valid => {
        if (valid) {
          editShopSorts(this.form).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              // 更新表格
              this.getAllLevel();
              this.addSortCon = false;
              this.showImage = false;
              this.fakefileList = [];
              this.fileListData = [];
              this.chosepictireid = [];
            } else {
              this.$message.danger(res.msg);
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    adLogoSuccess(res, file) {
      this.$message(res.msg);
      if (res.code == 1) {
        this.brandItem.logo = res.data.id;
      }
      this.logoUrl = URL.createObjectURL(file.raw);
    },
    // 上传图片
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.image_id = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //上传分类轮播图片
    productUploadImg(file) {
      var that = this;
      var formdata = new FormData();
      formdata.append("token", that.token);
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      addImage(formdata).then(res => {
        console.log("上传回调", res);
        var data = res.data;
        if (res.code == 200) {
          this.chosepictireid.push(res.data.id);
          this.form.image_ids = this.chosepictireid.join(",");
          var list = {};
          var index = 0;
          list.name = res.data.key;
          list.url = res.data.url;
          list.uid = file.file.uid;
          this.fakefileList.push(list);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    // 删除图片
    handleRemove(file) {
      console.log(file);
      console.log(this.fakefileList);
      var replaceArr = this.fakefileList;
      for (var i = 0; i < replaceArr.length; i++) {
        if (file.uid == replaceArr[i].uid) {
          replaceArr.splice(i, 1);
          this.chosepictireid.splice(i, 1);
          this.form.image_ids = this.chosepictireid.join(",");
          console.log(this.form.image_ids, "dffffffff");
          break;
        }
      }
    },
    //关闭编辑窗口
    closeDialog() {
      this.addSortCon = false;
      this.fakefileList = [];
      this.fileListData = [];
      this.chosepictireid = [];
    },
    // 分类图片上传
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      console.log(file, fileList);
      this.imgdata.image = file.raw;
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.image_id = res.data.id;
    },
    beforeUpload(file) {
      console.log(this.imgdata);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.imgdata = {
        token: this.token,
        type: "1",
        file_group: "1",
        app_id: this.app_id
      };
      this.getAllLevel();
      this.getScreenList();
      setTimeout(() => {
        this.loading = false;
      }, 800);
    });
  }
};
</script>
<style></style>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar2 {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 350px;
  height: 140px;
  display: block;
}
.avatar1 {
  width: 60px;
  height: 60px;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.brand-con {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.addNewClass {
  width: 100%;
  height: 100%;
  position: relative;
  .cursor {
    cursor: pointer;
  }
  .content {
    width: 96%;
    height: 80%;
    overflow-y: scroll;
    margin: 0 auto;
    border-radius: 3px;
    padding: 30px;
    margin-top: 20px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  }
}
</style>
